import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/home' },
  { path: 'home', loadChildren: () => import('./layout/home/home.layout.module').then(m => m.HomeLayoutModule) },
  { path: 'login', loadChildren: () => import('./layout/login/login.layout.module').then(m => m.LoginLayoutModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
